export const ActiveTimers = {
    NoLimitations: 'NoLimitations',
    OneActivePerEntity: 'OneActivePerEntity',
    OneActiveForAll: 'OneActiveForAll'
}
export const PROPERTIES = {
    TIMER_AUTOSTART: 'TimerAutoStart'
}